import styled, { css } from "styled-components";

export const PlaceHolder = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 0 auto;
	padding: 0.375rem 1rem;
	max-width: 100%;
	min-width: 1px;
	font-size: 1rem;
	height: calc(2.5rem - 2px);
	line-height: 1.75rem;
	position: absolute;
	top: -1px;
	width: max-content;
	z-index: 9;
	color: var(--dz-sys-input-placeholder-color);
	pointer-events: none;
	opacity: 0;

	${({ $showPlaceholder }) => {
		if ($showPlaceholder) {
			return css`
				opacity: 1;
			`;
		}
	}}
	${({ $innerHeader }) => {
		if ($innerHeader) {
			return css`
				top: 13px;
			`;
		}
	}};
`;

export const Container = styled.div`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	max-width: 100%;
`;

export const ContentEditable = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	flex: 1 0 auto;
	padding: 0.375rem 1rem;
	max-width: 100%;
	min-width: 1px;
	font-size: 1rem;
	min-height: calc(2.5rem - 2px);
	max-height: calc(10 * 1.75rem + 2 * 0.375rem + 1px);
	overflow-x: hidden;
	overflow-y: auto;
	overscroll-behavior-y: contain;
	outline: 0;
	z-index: 9;
	word-wrap: break-word;
	word-break: break-word;
	border-radius: var(--dz-sys-input-border-radius);

	${({ padding }) => {
		if (!padding) {
			return;
		}

		return css`
			padding-bottom: calc(${padding}px + 0.375rem);
		`;
	}}

	${({ isDisabled }) =>
		isDisabled &&
		css`
			opacity: 0.75;
		`}

		${({ customMaxHeight }) =>
		customMaxHeight &&
		css`
			max-height: ${customMaxHeight};
		`}

		
		${({ $innerHeader }) =>
		$innerHeader &&
		css`
			padding: 0 1rem 0.375rem 1rem;
		`}


	p {
		min-width: ${({ minWidthParagraph }) =>
			minWidthParagraph
				? `calc(100% - ${minWidthParagraph}px - 23px)`
				: "1px"};
		align-self: start;
	}

	p {
		margin-right: ${({ innerButtonsWidth }) =>
			innerButtonsWidth ? `calc(${innerButtonsWidth}px - 0.5rem)` : "0"};
	}

	.mention {
		display: inline;
		font-weight: bold;
		color: ${({ theme }) => theme.colors.primary};
	}

	&:hover,
	&:focus {
		outline: 0;
	}
`;

export const EditorWrapper = styled.div`
	position: relative;
	display: flex;
	box-sizing: border-box;
	background-color: transparent;
	outline: 0;
	cursor: text;
	min-height: calc(0.75rem + 7.5rem + 2px);
	background-color: var(--dz-sys-input-background-color);
	border-radius: var(--dz-sys-input-border-radius);
	border: 1px solid var(--dz-sys-input-border-color);
	overflow: hidden;

	${({ focused }) =>
		focused &&
		css`
			border: 1px solid var(--dz-sys-input-border-color-hover);
			box-shadow: var(--dz-sys-input-shadow);
		`};

	&:focus,
	&:hover {
		border: 1px solid var(--dz-sys-input-border-color-hover);
		box-shadow: var(--dz-sys-input-shadow);
	}

	${({ inline }) =>
		inline &&
		css`
			min-height: initial;
		`}

	${({ $innerHeader }) =>
		$innerHeader &&
		css`
			display: flex;
			flex-direction: column;
		`}

	${({ isDisabled }) => isDisabled && css``}

	span.mention {
		font-weight: bold;
		color: ${({ theme: { colors } }) => colors.primary};
	}
`;

export const MentionList = styled.div`
	position: relative;
	pointer-events: all;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	min-width: 220px;
	padding-top: 0.5rem;
	//max-width: 440px;

	a {
		display: flex;
		padding: 0.5rem 1rem;
		cursor: pointer;
	}

	a.selected {
		background: ${({ theme: { colors } }) => colors.menuItemHover};

		&:active {
			background-color: ${({ theme: { colors } }) =>
				colors.menuItemActive};
		}
	}
`;

export const DisabledOverlay = styled.div`
	cursor: not-allowed;
	position: absolute;
	z-index: 1000;
	left: -1px;
	right: -1px;
	top: -1px;
	bottom: -1px;
	border-radius: var(--dz-sys-input-border-radius);
	background: ${({ theme: { isDarkMode } }) =>
		isDarkMode ? "rgba(0, 0, 0, 0.35)" : "rgba(0, 0, 0, 0.05)"};

	${({ linkOnButtonToPayments }) =>
		linkOnButtonToPayments &&
		css`
			cursor: pointer;
		`}

	${({ aboutMe }) =>
		aboutMe &&
		css`
			background: transparent;
		`}
`;

export const MentionInput = styled("input")`
	display: block;
	box-sizing: border-box !important;
	padding: 0 1rem;
	width: 100%;
	font-size: 1rem;
	height: 2.5rem;
	line-height: 1.75rem;
	background-image: none;
	background-color: var(--dz-sys-input-background-color);
	border: 1px solid;
	border-color: var(--dz-sys-input-border-color);
	border-radius: var(--dz-sys-input-border-radius);
	color: var(--dz-sys-text-color);

	&:hover,
	&:focus-within {
		border-color: var(--dz-sys-input-border-color-hover);
		box-shadow: var(--dz-sys-input-shadow);
	}
`;
